import { ChangeDetectionStrategy, Component, DOCUMENT, inject } from '@angular/core';
import { PushService } from '@core/push/push.service';
import { PushCodeModel } from '@core/push/push-code.model';
import { XlsxService } from '@core/utils/xlsx-service';
import { IconBsComponent } from '@ui/elements/icon-bs/icon-bs.component';
import { BsIconTypes } from '@ui/elements/icon-bs/bs-icon-types';
import { TranslatePipe } from '@ngx-translate/core';


/**
 * Control for XLSX export first table on page
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-export-control',
    templateUrl: './export-control.component.html',
    styleUrls: ['./export-control.component.scss'],
    imports: [
        IconBsComponent,
        TranslatePipe,
    ],
    providers: [XlsxService],
})
export class ExportControlComponent {
    readonly #push: PushService = inject(PushService);
    readonly #xlsxService: XlsxService = inject(XlsxService);
    readonly #document: Document = inject(DOCUMENT);

    public handlerExport(): void {
        const tablesOnPage: HTMLCollection = this.#document.getElementsByClassName('table');

        if (tablesOnPage?.length) {
            this.#xlsxService.exportTablesOnPageToExcelFile(tablesOnPage);
        } else {
            this.#push.success(PushCodeModel.NoData);
        }
    }

    protected readonly bsIconTypes: typeof BsIconTypes = BsIconTypes;
}
